const cate = {
    namespaced: true,
    state: {
        point: {
            id: '',
            title: ''
        },
        cateContent: '',
        departList: [],
        form: {
            cate: "",
            address: "",
            img: "",
            content: "",
            timelimit: '',
            area_id: '',
        }
    },
    getters: {
        get: (state) => key => state[key]
    },
    mutations: {
        set: (state, { key, data }) => { state[key] = data }
    },
    actions: {
        setPoint({ commit }, data) {
            commit('set', { key: 'point', data })
            window.localStorage.setItem('point', JSON.stringify(data))
        },
        setCateList({ state, commit }, data) {
            const { cate, content } = data || {}
            state.form.cate = cate
            commit('set', { key: 'cateContent', data: content })
            window.localStorage.setItem('cateContent', content)
            window.localStorage.setItem('form', JSON.stringify(state.form))
        },
        setReport({ state, }, data) {
            const { address, img, content } = data || {}
            state.form.address = address
            state.form.img = img
            state.form.content = content
            window.localStorage.setItem('form', JSON.stringify(state.form))
        },
        setOrder({ state, }, data) {
            const { timelimit, area_id } = data || {}
            state.form.timelimit = timelimit
            state.form.area_id = area_id
            window.localStorage.setItem('form', JSON.stringify(state.form))
        },
        setDepartList({ commit }, data) {
            commit('set', { key: 'departList', data })
            window.localStorage.setItem('departList', JSON.stringify(data))
        },
        clear({ state, }, data) {
            window.localStorage.removeItem('point')
            window.localStorage.removeItem('cateContent')
            window.localStorage.removeItem('form')
            window.localStorage.removeItem('departList')
            state.form = {
                cate: "",
                address: "",
                img: "",
                content: "",
                timelimit: '',
                area_id: ''
            }
            state.point = {}
            state.cateContent = ""
            state.departList = []
        }
    }
}
export default cate